// Hash prefix for marker deep-links (e.g. #marker-15)
export const HASH_PREFIX = 'marker-';

// Aspect ratio class for the map container
export const ASPECT_RATIO_CLASS = 'aspect-square md:aspect-16/10';

// Clustering: markers are clustered up to this zoom level
export const CLUSTER_MAX_ZOOM = 16;
// Clustering radius in pixels (must match the useSupercluster options)
export const CLUSTER_RADIUS = 75;

// Vienna as fallback center
export const DEFAULT_CENTER = { lat: 48.2082, lng: 16.3738 };
